import { makeStyles } from '@surveycake/rc';

export const useStyles = makeStyles([
  [
    'radioClassNameMobile',
    theme => `
			border: none;
			background-color: ${theme.survey.color.light};
			margin: 0 0 4px 0;
    `
  ],
  [
    'textClassName',
    theme => [
      `
        font-size: 1em;
        color: ${theme.survey.color.default};
			`
    ]
  ],
  [
    'categoryText',
    theme => [
      `
        :lang(ar){
          transform: scaleX(-1);
          direction: rtl;
        }
				position: relative;
				line-height: 1.5;
				font-size: 1em;
				font-weight: 300;
				color: ${theme.survey.color.black};
				margin: 0 0 10px 0;
			`
    ]
  ],
  [
    'rowContainer',
    `
    	margin: 30px 0 60px 0;
		`
  ]
]);
